<template>
  <div class="operateWork">
    <div class="ow_title">
      结果呈现
    </div>
    <div class="img_module">
      <div class="left_button" @click="prev('reduce')">
      </div>
      <div class="center_box">
        <div class="i_left_module">
          <div class="i_font HuXiaoBo">
            <div>
              保障前
            </div>
          </div>
          
        </div>
        <div class="center_wrap">
          <el-carousel v-if="dataList.length" @change="carouselActive" indicator-position="none" :initial-index="activeIndex" ref="img" arrow="never"  :interval="6000">
            <el-carousel-item v-for="item in dataList" :key="item">
              <div class="i_mid_module">
                <div class="i_img">
                  <el-carousel v-if="item.clockIn" indicator-position=""  direction="vertical" :initial-index="0"  arrow="never"  :interval="4000">
                    <el-carousel-item v-for="imgList in item.clockIn" :key="item">
                      <img :src="imgList?imgList:''" alt=""/>
                    </el-carousel-item>
                  </el-carousel>
                  
                </div>
                <div class="mid_img">
                  <span class="work_type pangMen">
                    {{ item.ticketTypeName }}
                  </span>
                </div>
                <div class="i_img i_img_r">
                  <el-carousel v-if="item.workPicture" direction="vertical" indicator-position="" :initial-index="0"  arrow="never"  :interval="4000">
                    <el-carousel-item v-for="imgList in item.workPicture" :key="item">
                      <img :src="imgList?imgList:''" alt=""/>
                    </el-carousel-item>
                  </el-carousel>
                  <!-- <img :src="item.clockIn?item.workPicture[0]:''" alt=""> -->
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="i_right_module">
          
          <div class="i_font HuXiaoBo">
            <div>
              保障后
            </div>
          </div>
        </div>
      </div>
      <div class="right_button" @click="next('add')"></div>
    </div>
  </div>
</template>

<script>
import jsonData from  '/public/static/js/json/operatieCenter.json';
export default {
  name: 'operateWork',
  data() {
    return {
      activeIndex: 0,
      timer: null,
      imgList: [],
      paramsList: {
        pageNo: 1,
        pageSize: 50,
      },
      dataList: [],
      img: require("./img/1.jpeg"),
      dateArr: [
        new Date(new Date().setHours(0, 0, 0, 0)),
        new Date(),
      ],
    }
  },
  created() {
    this.getDictList(17)
    // this.getTableData()
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  methods: {
    // 字典接口
    getDictList (typeId) {
      let that = this
      let url = CONFIG.requestName + this.$apiOpt.getDictList;
      let params = {
          typeId
      }
      this.$apiUtils
          .get(url, params)
          .then(data => {
              if (typeId == 17) {
                  that.getTableData(data)
              } else if (typeId == 15) {
                  this.resultList = data
              }

          });
        },
    changImg(type) {
      if (type === 'add') {
        
        // if (this.activeIndex + 1 > this.imgList.length - 1) {
        //   this.activeIndex = 0;
        // } else {
        //   this.activeIndex++;
        // }
      } else {
        // if (this.activeIndex - 1 === 0) {
        //   this.activeIndex = this.imgList.length - 1;
        // } else {
        //   this.activeIndex--;
        // }
        prev()
      }
    },

    async getTableData (type) {
      let that = this
      let params = { ...this.paramsList }
      let url = ''
      // params.startTime = ''
      params.endTime = Date.parse(this.dateArr[1])
      params.customerId = that.$store.state.customerId
      params.workStatus = 1 // 任务状态 ： 已解决
      url = CONFIG.requestName + this.$apiOpt.getTicketDetailList;
      this.$apiUtils
          .get(url, params)
          .then(data => {
            for (let item of type) {
              for (let val of data) {
                if (item.key == val.ticketType) {
                  val.ticketTypeName = item.value
                }
                
                
              }
            }
            for (let val of data) {
              if (val.workPicture) {
                  val.workPicture = val.workPicture.split(',')
                }
                if (val.clockIn) {
                  val.clockIn = val.clockIn.split(',')
                }
            }
            that.dataList = data || []
            console.log('dataList21', that.dataList)
          });
    },

    next() {
      this.$refs.img.next();
    },

    prev() {
      this.$refs.img.prev();
    },

    carouselActive() {

    }
  }
}
</script>

<style lang="scss" scoped>
.operateWork {
  height: 100%;
  width: 100%;
  position: relative;
  left: 0;
  top: 0;
  .ow_title {
    position: absolute;
    left: 0;
    top: 10px;
    font-size: 30px;
    color: #63F2EF;
    padding-left: 40px;
    font-weight: 600;
  }
  .img_module {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    .left_button {
      @include bg-box(100px, 240px, 'left_button.png');
      cursor: pointer;
    }

    .center_box {
      display: flex;
      align-items: center;
      .center_wrap {
        width: 1550px;
        // display: flex;
        // align-items: center;
        height: 320px;
      }
      .i_left_module {
        display: flex;
        margin-right: 0px;
        flex: 1;
        .i_font {

          display: flex;
          align-items: center;
          width: 140px;
          justify-content: center;

          div {
            color: #ffb013;
            font-size: 48px;
            width: 50px;
          }
        }

        .i_img {
          width: 520px;
          height: 320px;
          border: 1px solid #ffb013;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .i_mid_module {
        // width: 320px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .i_img {
          width: 520px;
          height: 320px;
          border: 2px solid #ffb013;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }
        .i_img_r {
          border: 2px solid #399cff;
        }
        .mid_img {
          @include bg-box(280px, 260px, 'center_box.png');
          margin: 0px 100px 0;
          position: relative;

          .work_type {
            font-size: 42px;
            width: 100px;
            position: absolute;
            left: 52%;
            top: 36%;
            transform: translate(-50%, -50%);
          }
        }

        .button_list {
          display: flex;
          justify-content: space-between;
          width: 100%;
          align-items: center;

          .item_button {
            width: 40px;
            height: 8px;
            border-radius: 10px;
            background: #bcc8e6;
            cursor: pointer;
          }
        }

      }

      .i_right_module {
        display: flex;
        // margin-left: 40px;
        flex: 1;
        .i_font {
          display: flex;
          align-items: center;
          width: 140px;
          justify-content: center;

          div {
            font-size: 48px;
            width: 50px;
            color: #33c4fd;
          }
        }

        .i_img {
          width: 520px;
          height: 320px;
          border: 1px solid #33c4fd;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .right_button {
      cursor: pointer;
      @include bg-box(100px, 240px, 'right_button.png');
    }
  }
}
</style>

<style lang="scss">
.operateWork {
  .el-carousel__indicator--vertical .carousel__button{
    width: 20px !important;
    height: 20px !important;
    background: #A9A9A9;
    border-radius: 5px 5px 5px 5px;
  }
  .el-carousel__indicator button {
    width: 10px !important;
    height: 10px !important;
    background: #A9A9A9;
    border-radius: 5px 5px 5px 5px;
  }
  .el-carousel__indicator.is-active button {
    background: linear-gradient(90deg, #00A3FF 0%, #B2FEFC 100%);
  }
  .el-carousel__container {
    height: 345px !important;
  }
}
</style>
